import script from "./Investor.vue?vue&type=script&lang=ts&setup=true"
export * from "./Investor.vue?vue&type=script&lang=ts&setup=true"

import "./Investor.vue?vue&type=style&index=0&id=0cb0217e&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev-En\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cb0217e"]])

export default __exports__